/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ContactSummary,
    ContactSummaryFromJSON,
    ContactSummaryFromJSONTyped,
    ContactSummaryToJSON,
} from './ContactSummary';
import {
    Feedback,
    FeedbackFromJSON,
    FeedbackFromJSONTyped,
    FeedbackToJSON,
} from './Feedback';
import {
    FormResponse,
    FormResponseFromJSON,
    FormResponseFromJSONTyped,
    FormResponseToJSON,
} from './FormResponse';
import {
    OrderSummary,
    OrderSummaryFromJSON,
    OrderSummaryFromJSONTyped,
    OrderSummaryToJSON,
} from './OrderSummary';
import {
    ProgramAttendee,
    ProgramAttendeeFromJSON,
    ProgramAttendeeFromJSONTyped,
    ProgramAttendeeToJSON,
} from './ProgramAttendee';
import {
    ProgramEventSummary,
    ProgramEventSummaryFromJSON,
    ProgramEventSummaryFromJSONTyped,
    ProgramEventSummaryToJSON,
} from './ProgramEventSummary';
import {
    RegistrationObjectType,
    RegistrationObjectTypeFromJSON,
    RegistrationObjectTypeFromJSONTyped,
    RegistrationObjectTypeToJSON,
} from './RegistrationObjectType';
import {
    RegistrationOption,
    RegistrationOptionFromJSON,
    RegistrationOptionFromJSONTyped,
    RegistrationOptionToJSON,
} from './RegistrationOption';
import {
    RegistrationStatus,
    RegistrationStatusFromJSON,
    RegistrationStatusFromJSONTyped,
    RegistrationStatusToJSON,
} from './RegistrationStatus';
import {
    SessionCreditSummary,
    SessionCreditSummaryFromJSON,
    SessionCreditSummaryFromJSONTyped,
    SessionCreditSummaryToJSON,
} from './SessionCreditSummary';

/**
 * 
 * @export
 * @interface Registration
 */
export interface Registration {
    /**
     * 
     * @type {string}
     * @memberof Registration
     */
    id: string;
    /**
     * 
     * @type {RegistrationObjectType}
     * @memberof Registration
     */
    object: RegistrationObjectType;
    /**
     * 
     * @type {RegistrationStatus}
     * @memberof Registration
     */
    status: RegistrationStatus;
    /**
     * 
     * @type {ProgramEventSummary}
     * @memberof Registration
     */
    event: ProgramEventSummary;
    /**
     * 
     * @type {string}
     * @memberof Registration
     */
    online_event_url?: string;
    /**
     * 
     * @type {RegistrationOption}
     * @memberof Registration
     */
    option: RegistrationOption;
    /**
     * 
     * @type {ContactSummary}
     * @memberof Registration
     */
    contact: ContactSummary;
    /**
     * 
     * @type {ProgramAttendee}
     * @memberof Registration
     */
    program_attendee?: ProgramAttendee;
    /**
     * 
     * @type {OrderSummary}
     * @memberof Registration
     */
    order?: OrderSummary;
    /**
     * 
     * @type {SessionCreditSummary}
     * @memberof Registration
     */
    session_credit?: SessionCreditSummary;
    /**
     * 
     * @type {FormResponse}
     * @memberof Registration
     */
    form_response: FormResponse;
    /**
     * 
     * @type {Feedback}
     * @memberof Registration
     */
    feedback?: Feedback;
    /**
     * 
     * @type {Date}
     * @memberof Registration
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof Registration
     */
    updated: Date;
}

export function RegistrationFromJSON(json: any): Registration {
    return RegistrationFromJSONTyped(json, false);
}

export function RegistrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Registration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': RegistrationObjectTypeFromJSON(json['object']),
        'status': RegistrationStatusFromJSON(json['status']),
        'event': ProgramEventSummaryFromJSON(json['event']),
        'online_event_url': !exists(json, 'online_event_url') ? undefined : json['online_event_url'],
        'option': RegistrationOptionFromJSON(json['option']),
        'contact': ContactSummaryFromJSON(json['contact']),
        'program_attendee': !exists(json, 'program_attendee') ? undefined : ProgramAttendeeFromJSON(json['program_attendee']),
        'order': !exists(json, 'order') ? undefined : OrderSummaryFromJSON(json['order']),
        'session_credit': !exists(json, 'session_credit') ? undefined : SessionCreditSummaryFromJSON(json['session_credit']),
        'form_response': FormResponseFromJSON(json['form_response']),
        'feedback': !exists(json, 'feedback') ? undefined : FeedbackFromJSON(json['feedback']),
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
    };
}

export function RegistrationToJSON(value?: Registration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': RegistrationObjectTypeToJSON(value.object),
        'status': RegistrationStatusToJSON(value.status),
        'event': ProgramEventSummaryToJSON(value.event),
        'online_event_url': value.online_event_url,
        'option': RegistrationOptionToJSON(value.option),
        'contact': ContactSummaryToJSON(value.contact),
        'program_attendee': ProgramAttendeeToJSON(value.program_attendee),
        'order': OrderSummaryToJSON(value.order),
        'session_credit': SessionCreditSummaryToJSON(value.session_credit),
        'form_response': FormResponseToJSON(value.form_response),
        'feedback': FeedbackToJSON(value.feedback),
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
    };
}

